import { Icon, IconSizeClasses } from '@eppendorf/vnls-react-components';
import { type ReactElement } from 'react';

type RunRecordInfoIconName =
  | 'centrifuge-large'
  | 'generic'
  | 'document'
  | 'multi-step-program'
  | 'spin'
  | 'temperature'
  | 'start';

export function getRunTypeIcon(runType: string | null): RunRecordInfoIconName {
  switch (runType) {
    case 'MultiStep':
      return 'multi-step-program';
    case 'SingleStep':
      return 'document';
    case 'ShortSpin':
      return 'spin';
    case 'FastTemp':
      return 'temperature';
    default:
      return 'start';
  }
}

export interface RunRecordInfoCellProps {
  iconName: RunRecordInfoIconName;
  title: string;
  subtitle?: string;
}

export function RunRecordInfoCell({
  iconName,
  title,
  subtitle,
}: RunRecordInfoCellProps): ReactElement {
  return (
    <div className="run-record-cell flex flex__ai--center gap-s">
      <Icon name={iconName} size={IconSizeClasses.XSmall} />
      <div className="run-record-cell__content flex flex__dir--column gap-xxs">
        <span className="run-record-cell__title font-weight-bold">{title}</span>
        {subtitle ? (
          <span className="run-record-cell__subtitle color-gray-800">{subtitle}</span>
        ) : null}
      </div>
    </div>
  );
}
